import {request} from '@/utils/request'

// 合作方 - 列表
export function getPartnerList(data) {
  return request('GET', '/partner/page', data, true)
}
export function getPartnerListAll(data) {
  return request('GET', '/partner/list', data, true)
}

// 合作方 - 添加
// export function postPartnerAdd(data) {
//   return request('POST', '/Partner/add', data, true)
// }
export function postPartnerAdd(data) {
  return request('POST', '/partner', data, true)
}

// 合作方 - 详情
export function getPartnerInfo(data) {
  return request('GET', '/Partner/EditOrInfo', data, true)
}

// 合作方 - 编辑
// export function postPartnerEdit(data) {
//   return request('POST', '/Partner/edit', data, true)
// }
export function postPartnerEdit(data) {
  return request('PUT', '/partner', data, true)
}



// 合作方端 - 列表
export function getPartnerIndexList(data) {
  return request('GET', '/Project/partnerIndex', data, true)
}

// 合作方端 - 添加
export function postPartnerIndexAdd(data) {
  return request('POST', '/Project/add', data, true)
}

// 合作方端 - 详情
export function getPartnerIndexInfo(data) {
  return request('GET', '/Project/partnerInfo', data, true)
}
export function getPartnerId(id,data) {
  return request('GET', '/partner/'+id, data, true)
}
// 合作方端 - 编辑      修改
export function postPartnerIndexEdit(data) {
  return request('PUT', '/partner', data, true)
}

// 合作方端 - 提交
export function postPartnerIndexPush(data) {
  return request('POST', '/Project/push', data, true)
}



// 系统通知 - 列表
export function getMessageList(data) {
  return request('GET', '/Notice/index', data, true)
}


// 系统通知 - 已读
export function postMessageEdit(data) {
  return request('POST', '/Notice/status', data, true)
}




